window.jdgm = window.jdgm || {};
window.jdgm.SHOP_DOMAIN = '2etjzk-rv.myshopify.com';
window.jdgm.PLATFORM = 'shopify';

(function () {
  if (!document.querySelector('script[data-elovia-rc]')) {
    var boot = document.querySelector('script[src*="elovia-judgeme-loader.js"]');
    if (boot) {
      var carousel = document.createElement('script');
      carousel.src = boot.src.replace('elovia-judgeme-loader.js', 'elovia-reviews-carousel.js');
      carousel.defer = true;
      carousel.setAttribute('data-elovia-rc', '1');
      document.head.appendChild(carousel);
    }
  }

  if (document.querySelector('script[data-elovia-judgeme-loader="1"]')) return;
  var s = document.createElement('script');
  s.setAttribute('data-cfasync', 'false');
  s.className = 'jdgm-script';
  s.async = true;
  s.src = 'https://cdnwidget.judge.me/shopify_v2.js';
  s.setAttribute('data-elovia-judgeme-loader', '1');
  document.head.appendChild(s);
})();

(function () {
  function repositionEloviaReviews() {
    var finalCta = document.querySelector('section[id*="__final_cta"]');
    var reviewsRoot = document.getElementById('elovia-customer-reviews');
    if (!finalCta || !reviewsRoot) return;

    var sectionWrapper = reviewsRoot.closest('section[id*="__customer_reviews"]');
    var nodeToMove = sectionWrapper || reviewsRoot;

    if (nodeToMove.previousElementSibling === finalCta) return;

    finalCta.insertAdjacentElement('afterend', nodeToMove);

    var duplicates = document.querySelectorAll('#elovia-customer-reviews');
    for (var i = 1; i < duplicates.length; i += 1) {
      var dupSection = duplicates[i].closest('section[id*="__customer_reviews"]') || duplicates[i];
      dupSection.remove();
    }
  }

  function scheduleReposition() {
    repositionEloviaReviews();
    window.setTimeout(repositionEloviaReviews, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReposition);
  } else {
    scheduleReposition();
  }
})();
